const ImportantNote = ({ ios, samsung, commonMessage }) => {
  return (
    <div className="device-note">
      <p class="mt-3">
        <b>IMPORTANT</b>
      </p>
      <p>
        Check your device is <b>NOT LOCKED</b> to a single network.
      </p>
      {ios && <p>Recommend iOS version: iOS 13.3 or later.</p>}
      {ios && (
        <p>
          Note: iPhone and iPad models sold in mainland China are not equipped
          with an eSIM function.
        </p>
      )}
      {samsung && (
        <p>
          All Samsung <b>FE models</b> (except S23 FE) are <b>NOT</b> eSIM
          compatible
        </p>
      )}
      {commonMessage && (
        <p>
          Note: eSIM functionality may not be available in some country or
          regional variants.
        </p>
      )}
      <p class="mt-3">
        <b> Quick eSIM check</b>
      </p>
      <p>
        Dial <b>*#06#</b> on your phone’s native dialer.
      </p>
      <p>If your device supports eSIM, an EID value will be displayed.</p>
    </div>
  );
};

export default ImportantNote;
